export default __webpack_public_path__ + "static/media/ola.59a64216.jfif";